import React, { useState } from 'react';
import {
	Button,
	useCreateController, useNotify, useRefresh, useResourceContext,
	useTranslate,
} from 'react-admin';
// eslint-disable-next-line import/no-extraneous-dependencies
import { CreateContextProvider, ResourceContextProvider } from 'ra-core';
import Dialog from '@mui/material/Dialog';

const CreateInDialogButton = (props) => {
	const {
		children,
		maxWidth,
		fullWidth,
		resource: resourceByButton,
		record,
	} = props;
	const [open, setOpen] = useState(false);
	const translate = useTranslate();
	const resourceByContext = useResourceContext();
	const resource = resourceByButton || resourceByContext;
	const handleClick = () => {
		setOpen(true);
	};
	const handleStateChange = () => {
		setOpen(false);
	};
	const refresh = useRefresh();
	const notify = useNotify();
	const cc = useCreateController({
		redirect: false,
		resource,
		record,
		mutationOptions: {
			onSuccess: () => {
				notify('ra.notification.created', {
					type: 'info',
					messageArgs: { smart_count: 1 },
					undoable: true,
				});
				handleStateChange();
				refresh();
			},
		},
	});

	return (
		<>
			<Button
				onClick={handleClick}
				type="button"
				label={translate('ra.action.create')}
			/>
			{
				open
					? (
						<Dialog
							open={open}
							onClose={handleStateChange}
							maxWidth={maxWidth}
							fullWidth={fullWidth}
						>
							<ResourceContextProvider value={resource}>
								<CreateContextProvider value={{ ...cc }}>
									{children}
								</CreateContextProvider>
							</ResourceContextProvider>
						</Dialog>
					)
					: null
			}
		</>
	);
};

export default CreateInDialogButton;
